export function rangeIso(days: number): { from: string; to: string } {
  const to = new Date();
  const from = new Date(to.getTime() - days * 24 * 60 * 60 * 1000);
  return { from: from.toISOString(), to: to.toISOString() };
}

export function formatTokens(n?: number | null): string {
  if (n == null) return '—';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
}

export function formatPct(n?: number | null): string | null {
  if (n == null) return null;
  const sign = n > 0 ? '+' : '';
  return `${sign}${n}%`;
}

export function isCostQuery(text: string): boolean {
  const lower = text.toLowerCase();
  return (
    lower.includes('cost') ||
    lower.includes('invoice') ||
    lower.includes('charge') ||
    lower.includes('spend') ||
    lower.includes('$')
  );
}
